import { createSelector } from 'reselect';

export const getTimeSlotList = createSelector(
  state => state.fittestBooking.timeSlotData,
  timeSlotData => timeSlotData || {},
);

export const getBookingLoadingStatus = state =>
  state.fittestBooking.loadingStatus;

export const getCurrentHoldingSlot = state =>
  state.fittestBooking.currentHoldingSlot;

export const getSelectedBookingSlot = state =>
  state.fittestBooking.selectedBookingSlot;

export const getSelectedProfileSlot = createSelector(
  state => state.fittestBooking.selectedBookingSlot.bookingData,
  bookingData => bookingData || null,
);
